import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/home/index.vue'
import Mine from '../pages/mine/index.vue'
import Choose from '../pages/choose/index.vue'
import Video from '../pages/video/index.vue'
import Game from '../pages/game/index.vue'
import Login from '../pages/login/index.vue'
import Register from '../pages/login/register.vue'
Vue.use(VueRouter)

const routes = [
    {path:'/',redirect:'/Home',meta:{title:'Home'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'Home'}},
    {path:'/Choose',name:'choose',component:Choose,meta:{title:'Choose'}},
    {path:'/List',name:'list',component:() => import('../pages/choose/list.vue'),meta:{title:'Selected List'}},
    {path:'/Profile',name:'profile',component:() => import('../pages/choose/profile.vue'),meta:{title:'Profile Details'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'My Page'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'Video'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'Game'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'Login'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'Register'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:() => import('../pages/mine/ServiceOnline.vue'),meta:{title:'Online Service'}},
    {path:'/ServicePage',name:'ServicePage',component:() => import('../pages/mine/ServicePage.vue'),meta:{title:'Service Details'}},
    {path:'/Setting',name:'Setting',component:() => import('../pages/mine/Setting.vue'),meta:{title:'Settings'}},
    {path:'/Infomation',name:'Infomation',component:() => import('../pages/mine/Infomation.vue'),meta:{title:'Basic Information'}},
    {path:'/Setname',name:'Setname',component:() => import('../pages/mine/Setname.vue'),meta:{title:'Change Name'}},
    {path:'/Setsex',name:'Setsex',component:() => import('../pages/mine/Setsex.vue'),meta:{title:'Change Gender'}},
    {path:'/Language',name:'Language',component:() => import('../pages/mine/Language.vue'),meta:{title:'Language Selection'}},
    {path:'/Recharge',name:'Recharge',component:() => import('../pages/mine/Recharge.vue'),meta:{title:'Recharge'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:() => import('../pages/mine/SetPayPassword.vue'),meta:{title:'Payment Password'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:() => import('../pages/mine/SetLoginPassword.vue'),meta:{title:'Login Password'}},
    {path:'/Lottery',name:'Lottery',component:() => import('../pages/lottery/index.vue'),meta:{title:'Lottery Details'}},
    {path:'/Notice',name:'Notice',component:() => import('../pages/mine/Notice.vue'),meta:{title:'Notice'}},
    {path:'/PlayVideo',name:'PlayVideo',component:() => import('../pages/video/PlayVideo.vue'),meta:{title:'Play Video'}},
    {path:'/Setbank',name:'Setbank',component:() => import('../pages/mine/Setbank.vue'),meta:{title:'Enter Bank Card'}},
    {path:'/BindCard',name:'BindCard',component:() => import('../pages/mine/BindCard.vue'),meta:{title:'Bind Bank Card'}},
    {path:'/Withdraw',name:'Withdraw',component:() => import('../pages/mine/Withdraw.vue'),meta:{title:'Withdraw'}},
    {path:'/Personalreport',name:'Personalreport',component:() => import('../pages/mine/Personalreport.vue'),meta:{title:'Personal Report'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:() => import('../pages/mine/WithdrawRecord.vue'),meta:{title:'Withdraw Record'}},
    {path:'/GameRecord',name:'GameRecord',component:() => import('../pages/mine/GameRecord.vue'),meta:{title:'Game Record'}},
    {path:'/RechargeRecord',name:'RechargeRecord',component:() => import('../pages/mine/RechargeRecord.vue'),meta:{title:'Recharge Record'}},
    {path:'/Moneylog',name:'Moneylog',component:() => import('../pages/mine/Moneylog.vue'),meta:{title:'Transaction Record'}},
];

//生成路由实例
const router = new VueRouter({
    routes
})

router.beforeEach((to,from,next) => {
    const isPublic = to.name === 'login' || to.name === 'register';
    const token = localStorage.getItem('token');
    if (!token && !isPublic) {
        const invitationCode = to.query && to.query.invitation_code;
        next(invitationCode
            ? {name: 'register', query: {invitation_code: invitationCode}}
            : {name: 'login'});
        return;
    }
    document.title = to.matched[0].meta.title
    next()
})

export default router
